function esc(s) {
  return String(s == null ? "" : s).replace(/[&<>"']/g, (c) =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
}
const money = (v) =>
  "R " + Number(v || 0).toLocaleString("en-ZA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Renders an 80mm thermal-printer receipt in a new window and triggers print.
export function printReceipt(txn) {
  const rows = (txn.items || [])
    .map((it) => `<tr><td>${it.quantity} x ${esc(it.name || it.description || "Item")}</td><td class="r">${money(it.quantity * it.unit_price)}</td></tr>`)
    .join("");
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>${esc(txn.number)}</title>
  <style>
    @page { size: 80mm auto; margin: 0; }
    * { box-sizing: border-box; }
    body { width: 80mm; margin: 0; padding: 6mm 4mm; font-family: 'Courier New', ui-monospace, monospace; color: #000; font-size: 12px; line-height: 1.35; }
    .c { text-align: center; } .r { text-align: right; }
    h1 { font-size: 17px; margin: 0; letter-spacing: 1px; }
    .muted { color: #222; font-size: 11px; }
    hr { border: none; border-top: 1px dashed #000; margin: 6px 0; }
    table { width: 100%; border-collapse: collapse; } td { padding: 1px 0; vertical-align: top; }
    .total { font-size: 15px; font-weight: bold; }
  </style></head><body>
    <div class="c"><h1>BOCALLY HOLDINGS</h1>
      <div class="muted">Gas Exchange Point of Sale</div>
      <div class="muted">${new Date(txn.created_at || Date.now()).toLocaleString("en-ZA")}</div>
    </div>
    <hr>
    <div class="muted">Receipt: ${esc(txn.number)}<br>Operator: ${esc(txn.operator_name)}<br>Type: ${esc(txn.transaction_type || "sale")}</div>
    <hr>
    <table>${rows}</table>
    <hr>
    <table>
      <tr><td>Subtotal</td><td class="r">${money(txn.subtotal)}</td></tr>
      <tr><td>VAT (15% incl)</td><td class="r">${money(txn.vat_amount)}</td></tr>
      <tr class="total"><td>TOTAL</td><td class="r">${money(txn.total)}</td></tr>
      <tr><td>Paid (${esc(txn.payment_method)})</td><td class="r">${money(txn.total)}</td></tr>
    </table>
    <hr>
    ${txn.bank_account ? `<div class="c" style="margin-top:6px"><b>Banking Details</b><br>${txn.bank_account.bank}<br>${txn.bank_account.holder}<br>Acc: ${txn.bank_account.account_number} &nbsp; Branch: ${txn.bank_account.branch_code}</div>` : ""}
    <div class="c muted">Thank you for your business!<br>VAT No: 4001234567</div>
    <script>window.onload=function(){window.focus();window.print();setTimeout(function(){window.close();},400);};</script>
  </body></html>`;
  const w = window.open("", "_blank", "width=380,height=640");
  if (!w) { alert("Please allow pop-ups to print the receipt."); return; }
  w.document.open();
  w.document.write(html);
  w.document.close();
}
